import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import i18next from "i18next";
import { useParams } from "react-router-dom";
import {
  useGetGeneralParameters,
  useGetMultiUserCurrenciesByCountryId,
} from "@hooks/useGeneralParams";
import Header from "./components/Header";
import Contacts from "./components/Contacts/Contacts";
import QuoteSpecificCondition from "./components/QuoteSpecificCondition";
import QuoteConditions from "./components/QuoteConditions";
import QuoteServices from "./components/QuoteServices";
import { loadSingleQuote } from "../QuoteList/QuoteList.actionCreators";
import AddEditQuote from "../AddEditQuote";
import {
  SiteViewContainer,
  FlexRow,
  SectionContainer,
} from "./QuoteView.styled";

/**
 * site GeneralInfo,
 * Path - /site/view/{id}/quote-view-{quoteId}
 * @see See [Quote view page Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3081535496/Quote+-+View+page+-+General+layout)
 * @component
 */
const QuoteView = (props) => {
  const {
    t,
    quoteId,
    setIsRefeshSiteData,
    countryId,
    companyId,
    siteData,
    jobsiteNeedKickoff,
  } = props;

  const params = useParams();
  const [isRefreshDataAgain, setRefreshState] = useState(false);
  const [quoteData, setQuoteData] = useState([]);
  const [conditionData, setConditionData] = useState([]);
  const dispatch = useDispatch();

  const quoteInfo = useSelector((state) => state.quoteList.byId[quoteId]);

  const generalParams = useGetGeneralParameters();
  const currencyList = generalParams.countryCurrency;

  const [userCurrencyObject, setUserCurrencyObject] = useState(
    useGetMultiUserCurrenciesByCountryId(countryId)
  );

  useEffect(() => {
    if (
      Object.keys(userCurrencyObject).length === 0 &&
      Object.keys(generalParams).length > 0
    ) {
      setUserCurrencyObject(useGetMultiUserCurrenciesByCountryId(countryId));
    }
  }, [generalParams]);

  const selectedQuoteData = useSelector(
    (state) => state.quoteList.selectedQuote
  );

  const fetchQuoteInfo = () => {
    if (quoteId !== undefined) {
      dispatch(
        loadSingleQuote({
          quoteId,
        })
      );
    }
  };

  useEffect(() => {
    if (quoteId !== undefined) fetchQuoteInfo();
  }, [quoteId]);

  useEffect(() => {
    if (
      selectedQuoteData !== null &&
      parseInt(quoteId, 10) === parseInt(selectedQuoteData.id, 10)
    ) {
      setQuoteData(selectedQuoteData);
    } else if (
      quoteInfo !== undefined &&
      parseInt(quoteId, 10) === parseInt(quoteInfo.id, 10)
    ) {
      setQuoteData(quoteInfo);
    } else fetchQuoteInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteInfo, selectedQuoteData]);

  useEffect(() => {
    if (isRefreshDataAgain) {
      setRefreshState(false);
      fetchQuoteInfo();
    }
  }, [isRefreshDataAgain]);

  return (
    <>
      {params.path.split("-")[1] === "view" && quoteData?.id && (
        <SiteViewContainer className="site-view-enquiry">
          <FlexRow>
            <SectionContainer>
              <Header
                quoteData={quoteData}
                statusId={quoteData.status}
                setIsRefeshSiteData={setIsRefeshSiteData}
                setRefreshState={setRefreshState}
                jobsiteNeedKickoff={jobsiteNeedKickoff}
              />
              <QuoteServices
                data={quoteData}
                currencyList={currencyList}
                userCurrency={userCurrencyObject}
                setQuoteData={setQuoteData}
              />
              <QuoteConditions data={quoteData} />
              <Contacts quoteId={quoteData.id} data={quoteData.contacts} />
              <QuoteSpecificCondition
                conditionData={conditionData}
                setConditionData={setConditionData}
                data={quoteData.specificConditions}
                additionalCondition={quoteData.additionalSpecificConditions}
                page="view"
              />
            </SectionContainer>
          </FlexRow>
        </SiteViewContainer>
      )}
      {params.path.split("-")[1] === "edit" && quoteData?.id && (
        <AddEditQuote
          selectedQuote={quoteData}
          countryId={countryId}
          isEditMode={params.path.split("-")[1] === "edit"}
          quoteId={quoteId}
          siteId={params.id}
          companyId={companyId}
          setRefreshState={setRefreshState}
          siteData={siteData}
        />
      )}
      {params.path.split("-")[1] === "create" && (
        <AddEditQuote
          selectedQuote={quoteData}
          countryId={countryId}
          isEditMode={params.path.split("-")[1] === "edit"}
          quoteId={quoteId}
          siteId={params.id}
          companyId={companyId}
          setRefreshState={setRefreshState}
          siteData={siteData}
        />
      )}
    </>
  );
};
QuoteView.propTypes = {
  t: PropTypes.func.isRequired,
  jobsiteNeedKickoff: PropTypes.number,
};
QuoteView.defaultProps = {
  jobsiteNeedKickoff: 0,
};
export default withTranslation()(QuoteView);
